const base_routes = {
  auth: "/auth",
  enrollment: "/enrollment",
  rbac: "/rbac",
  bootstrap: "/bootstrap",
  transport: "/transport",
  finance: "/finance",
  bot: "/bot",
  myfinance: "/finance",
  academics: "/academics",
  audit: "/audit",
  lms: "/lms",
  dashboard: "/dashboard",
};

const endpoints = {
  auth: {
    login: "/login",
    logout: "/logout",
    listdrivers: "/list/drivers",
    refresh_token: "/refresh_token",
    signup: "/signup",
    adminSignup: "/admin/signup",
    verify_jwt: "/token/verify",
    adminList: "/list/admin",
    staffList: "/list/staff",
    listStaff: "/list/staff",
    OTPSend: "/otp/resend",
    OTPVerify: "/otp/verify",
    passwordReset: "/password/reset",
    passwordResetConfirm: "/password/reset/confirm",
    validatePsdToken: "/password-token/validate",

    //BEN
    listUsers: "/list/users",
    makeStaff: "/make-staff",
    employeesBulkUpload: "/employees/bulk-upload",
    employeesTemplate: "/employees/template",
  },
  enrollment: {
    student: "/student",
    emergency: "/emergency",
    guardian: "/guardian",
    uploads: "/uploads",
    get_application: "/get_application",
    adm_student: "/student/adm",
    adm_emergency: "/emergency/adm",
    adm_guardian: "/guardian/adm",
    adm_uploads: "/uploads/adm",
    submit: "/submit",
    update_status: "/update_status",
    interview: "/interview",
    adm_interview: "/interview/adm",
    related_applications: "/admission",
    terms: "/terms",
    academicYears: "/academic-years",
    academicYearsChoices: "/academic-years/choices",
    currentAcademicYear: "/academic-years/current",
    accommodation: "/accomodation",
    studentAccommodation: "/student-accomodation",
    unassignedAccomodation: "/student-accomodation/unassigned",
    applicationPrint: "/report-pdf/adm",

    //BEN
    students: "/student/finance",
    admission: "/admission",
    admissionBulkDelete: "/admission/bulk-delete",
    admissionBulkCancel: "/admission/bulk-cancel",
    studentLink: "/student/:id/link",
    settings: "/settings",
    enrollmentTemplate: "/template",
    enrollmentBulkUpload: "/bulk-upload",
  },
  rbac: {
    roles: "/roles",
    permissions: "/permissions",
    pages: "/pages",
    rolePages: "/roles/pages",
    rolePermissions: "/roles/permissions",
    userRoles: "/users/roles",
    mypages: "/pages/me",
    myperms: "/permissions/me",
    myRoles: "/roles/user",
  },
  bootstrap: {
    setup: "/setup",
    information: "/information",
    informationUpdate: "/information/update",
    informationLogo: "/information/logo",
    reportColumnSettings: "/report-column-settings",
    nations: "/nations",
    klass: "/klass",
    klassGroups: "/klass-groups", //n/a
    relationship: "/relationship",
    status: "/status",
    statusTransition: "/status-transition",
    subject: "/subject",
    stream: "/stream", //n/a

    signature: "/signature",

    //BEN
    classes: "/klass",
  },
  transport: {
    buses: "/bus",
    drivers: "/drivers",
    route: "/route",
    book: "/book",
    bookBulk: "/book/bulk",
    busstop: "/busstop",
    driverbusroute: "/driverbusroute",
    fuelrequests: "/fuel-requests", //transport manager(get), driver (post)
    myfuelrequest: "/fuel-requests/my_requests", //for drivers (get)
    pendingL1_approval: "/process-fuel-requests/pending_L1_approval", //(get fuel requests)
    pendingL2_approval: "/process-fuel-requests/pending_L2_approval", //(get)
    fuel_requests: "/process-fuel-requests", //(get,post,put,del)
    fuel_approve: "/process-fuel-requests/bulk", //for saving bulk fuel request
    fuel_coupons: "/fuel-coupons",
    fuel_coupons_active: "/fuel-coupons/active",
    fuel_coupons_expired: "/fuel-coupons/expired",
    fuel_coupons_exp_soon: "/fuel-coupons/expiring_soon",
    fuel_coupons_redeem: "/fuel-coupons/redeem",
    // fuel_stats: '/fuel-requests/statistics',
    fuel_approvals: "/fuel-approvals", //show list
    transporttype: "/transporttype",
    tariff: "/tariff",
    myrepairrequest: "/repair-requests/my_requests",
    repair_requests: "/repair-requests",
    repair_approval: "/process-repair-requests/bulk",
    repair_invoice: "/repair-invoice",
    repair_invoice_delete: "/repair-invoice-delete",
    active_trips: "/drivertrip/active",
    trip_history: "/drivertrip/admin_history",
    trip_history_info: "/drivertrip",
  },
  myfinance: {
    // Payment endpoints
    initiatePayment: "/payments/surepay/initiate",
    paymentCallback: "/payments/surepay/callback",
    paymentWebhook: "/payments/webhook",
    queryTransaction: "/payments/surepay/query-transaction",
    studentPayments: "/students/:spc/payments",
  },
  academics: {
    scoresheet: "/scoresheet/bulk",
    // class_subjects: '/subject-assignment/class_subjects',
    class_subjects_v2: "/subject-assignment/class_subjects_v2",
    my_subjects: "/subject-assignment/my_subjects",
    subject_assignments: "/subject-assignment",
    subject_assignments_save: "/subject-assignment/bulk",
    students: "/students",
    submit: "/submit",
    update_status: "/update_status",
    class_scores: "/scoresheet/class", //mostly used to fetch scores based on class,term and acadyr
    student_assessment: "/student-assessment/bulk",
    student_assessment_del: "/student-assessment/bulk_delete",
    preschool_learning_areas: "/preschool-grade",
    preschool_grades: "/preschool-remark",
    preschool_class_scores: "/preschool-score/class", //mostly used to fetch scores based on class,term and acadyr
    preschool_scoresheet: "/preschool-score/bulk", //mostly used to fetch score based on subject_teacher_id
    preschool_competences: "/preschool-score/competences",
    preschool_competence_settings: "/preschool-competence",
    attendance_save: "/attendance/bulk",
    attendance_remark: "/attendance-remark",
    attendance: "/attendance/subject-teacher", //mostly for get by subjectTeacherID
    student_academic_report: "/student-report",
    report_batch: "/report-batch", //merged report download by class/stream/acadyr/term
    student_attendance: "/attendance", //mostly for get by studentID

    // Grading Systems
    grading_systems: "/grading-system",
    grading_system_detail: "/grading-system/:id",
    grading_system_add_grade: "/grading-system/:id/add_grade",
    grading_system_calculate: "/grading-system/:id/calculate_grade",
    grades: "/grades",
    grade_detail: "/grades/:id",

    //BEN
    // Inspections
    inspections: "/inspections",
    inspectionDetail: "/inspections/:id",
    inspectionDownloadPdf: "/inspections/:id/download_pdf",
    inspectionRegeneratePdf: "/inspections/:id/regenerate_pdf",
    inspectionChoices: "/inspections/choices",

    // Student Search (Academic)
    studentSearch: "/student-search",
    studentSearchDetail: "/student-search/:identifier",

    // Circulars
    circulars: "/circulars",
    circularDetail: "/circulars/:id",
    circularActivate: "/circulars/:id/activate",
    circularDeactivate: "/circulars/:id/deactivate",
    circularArchive: "/circulars/:id/archive",
    circularFiles: "/circulars/:id/files",
    circularFileDelete: "/circulars/:id/files/:fileId",

    // Holiday Packages
    holidayPackages: "/holiday-packages",
    holidayPackageDetail: "/holiday-packages/:id",
    holidayPackageActivate: "/holiday-packages/:id/activate",
    holidayPackageDeactivate: "/holiday-packages/:id/deactivate",
    holidayPackageArchive: "/holiday-packages/:id/archive",
    holidayPackageFiles: "/holiday-packages/:id/files",
    holidayPackageFileDelete: "/holiday-packages/:id/files/:fileId",

    // Co-Curricular Calendars
    curricularCalendars: "/curricular-calendars",
    curricularCalendarDetail: "/curricular-calendars/:id",
    curricularCalendarSubmit: "/curricular-calendars/:id/submit",
    curricularCalendarApprove: "/curricular-calendars/:id/approve",
    curricularCalendarReject: "/curricular-calendars/:id/reject",
    curricularCalendarStudentSummary:
      "/curricular-calendars/:id/student-summary",

    // Calendar Events
    calendarEvents: "/calendar-events",
    calendarEventDetail: "/calendar-events/:id",
    calendarEventCancel: "/calendar-events/:id/cancel",
    calendarEventParticipants: "/calendar-events/:id/participants",
    calendarEventSummary: "/calendar-events/:id/summary",

    // Activity Participation
    activityParticipation: "/activity-participation",
    activityParticipationDetail: "/activity-participation/:id",
    activityParticipationEventSummary: "/activity-participation/event-summary",

    // Co-Curricular Dashboard
    coCurricularDashboard: "/co-curricular-dashboard",

    // Student Communications
    studentCommunications: "/communications/:studentID",

    // Class Teacher Assignments
    classTeachers: "/class-teacher",
    classTeacherDetail: "/class-teacher/:id",
    classTeacherSwap: "/class-teacher/:id/swap",
    classTeacherStudents: "/class-teacher/students",

    // Instructional Materials
    instructionalMaterials: "/instructional-materials",
    instructionalMaterialDetail: "/instructional-materials/:id",
    instructionalMaterialFiles: "/instructional-materials/:id/files",
    instructionalMaterialFileDelete:
      "/instructional-materials/:id/files/:fileId",
    instructionalMaterialSubmit: "/instructional-materials/:id/submit",
    instructionalMaterialUnlock: "/instructional-materials/:id/unlock",
    instructionalMaterialConfirmDelivery: "/instructional-materials/:id/confirm-delivery",
    instructionalMaterialReverseDelivery: "/instructional-materials/:id/reverse-delivery",

    // Material Approvals
    materialApprovals: "/material-approvals",
    materialApprovalsHodQueue: "/material-approvals/queue/hod",
    materialApprovalsSectionHeadQueue: "/material-approvals/queue/section-head",
    materialApprovalsDeputyHeadQueue: "/material-approvals/queue/deputy-head",
    materialApprovalsHeadteacherQueue: "/material-approvals/queue/headteacher",

    // Bursary and Academic Giants
    bursarySettings: "/bursary-settings",
    bursarySettingsDetail: "/bursary-settings/:id",
    giantsSettings: "/giants-settings",
    giantsSettingsDetail: "/giants-settings/:id",
    bursaryGiantsRankings: "/bursary-giants-rankings",
    bursaryGiantsRankingsTrigger: "/bursary-giants-rankings/trigger",
    giantsRecommendations: "/giants-recommendations",
    giantsRecommendationDetail: "/giants-recommendations/:id",
    giantsRecommendationsReview: "/giants-recommendations/review",
    giantsRecommendationsApprove: "/giants-recommendations/approve",
    giantsRecommendationsReject: "/giants-recommendations/reject",
    bursaryRecommendations: "/bursary-recommendations",
    bursaryRecommendationDetail: "/bursary-recommendations/:id",
    bursaryRecommendationsReview: "/bursary-recommendations/review",
    bursaryRecommendationsReject: "/bursary-recommendations/reject",
    bursaryRecommendationsSubmit: "/bursary-recommendations/submit",
    bursaryAllocations: "/bursary-allocations",
    bursaryAllocationsDashboard: "/bursary-allocations/dashboard",
    bursaryAllocationsApprove: "/bursary-allocations/approve",
    bursaryAllocationsReject: "/bursary-allocations/reject",
    bursaryAllocationsFinance: "/bursary-allocations/finance",
    bursaryAllocationsProcessed: "/bursary-allocations/processed",
    bursaryNotifications: "/bursary-notifications",
    bursaryNotificationsResend: "/bursary-notifications/resend",

    // Discipline Management
    disciplineCases: "/discipline-cases",
    disciplineCaseDetail: "/discipline-cases/:id",
    disciplineCaseSubmit: "/discipline-cases/:id/submit",
    disciplineCaseSendBack: "/discipline-cases/:id/send-back",
    disciplineCasesBulkEscalate: "/discipline-cases/bulk-escalate",
    disciplineCasesBulkClose: "/discipline-cases/bulk-close",
    disciplineEscalationSteps: "/discipline-escalation-steps",
    disciplineEscalationStepDetail: "/discipline-escalation-steps/:id",
    disciplineEscalationStepResolve: "/discipline-escalation-steps/:id/resolve",
    disciplineEvidence: "/discipline-evidence",
    disciplineEvidenceDetail: "/discipline-evidence/:id",
    disciplineSanctions: "/discipline-sanctions",
    disciplineSanctionDetail: "/discipline-sanctions/:id",
    disciplineSanctionsBulkApprove: "/discipline-sanctions/bulk-approve",
    disciplineSanctionsBulkLock: "/discipline-sanctions/bulk-lock",
    disciplineSeverityDeductions: "/discipline-cases/severity-deductions",
    disciplineSeverityDeductionsValidate: "/discipline-cases/severity-deductions/validate",

    appraisalCycles: "/appraisal-cycle",
    appraisalRuns: "/appraisal-cycle-runs",
    appraisalRecords: "/staff-appraisal-records",
    appraisalWeights: "/appraisal-component-weights",
    appraisalBands: "/appraisal-score-bands",
    appraisalConfigs: "/appraisal-scoring-configs",
    appraisalNotes: "/appraisal-supervisor-notes",
    appraisalCriteria: "/appraisal-r-criteria",
    appraisalFiveR: "/appraisal-five-r-scores",

    // Academic Analysis — Aggregation Runs
    aggregationRuns: "/aggregation-runs",
    aggregationRunDetail: "/aggregation-runs/:id",
    aggregationRunTrigger: "/aggregation-runs/trigger",

    // Academic Analysis — Metric Snapshots
    aggregationSnapshots: "/aggregation-snapshots",
    aggregationSnapshotDetail: "/aggregation-snapshots/:id",
    snapshotHeatmap: "/aggregation-snapshots/heatmap",
    snapshotClassGroupSummary: "/aggregation-snapshots/class-group-summary",
    snapshotSchoolWide: "/aggregation-snapshots/school-wide",
    snapshotStreamDrilldown: "/aggregation-snapshots/stream-drilldown",
    snapshotStreamComparison: "/aggregation-snapshots/stream-comparison",
    snapshotTrend: "/aggregation-snapshots/trend",

    // Academic Analysis — Reports & Review
    analysisReports: "/analysis/reports",
    analysisReportDetail: "/analysis/reports/:id",
    analysisReportDownload: "/analysis/reports/:id/download",
    analysisReportActions: "/analysis/reports/:reportId/actions",
    analysisFlagStatus: "/analysis/review-actions/:actionId/flag-status",
    analysisOpenFlags: "/analysis/open-flags",
  },

  //BEN ENDPOINTS
  bot: {
    // Categories
    categories: "/categories",
    categoryDetail: "/categories/:id",

    // Items
    items: "/items",
    itemDetail: "/items/:id",

    // Brands
    brands: "/brands",
    brandDetail: "/brands/:id",
    updateStock: "/brands/:id/update_stock",

    // Size Variants
    sizeVariants: "/size-variants",
    sizeVariantDetail: "/size-variants/:id",

    // Requirement Templates
    requirementTemplates: "/requirement-templates",
    requirementTemplateDetail: "/requirement-templates/:id",

    // Requirement Items (linking items to templates)
    requirementItems: "/requirement-items",
    requirementItemDetail: "/requirement-items/:id",

    // Clearance Assignments
    clearanceAssignments: "/clearance-assignments",
    clearanceAssignmentDetail: "/clearance-assignments/:id",
    bulkAssignments: "/clearance-assignments/bulk_create",
    clearanceDiscount: "/clearance-assignments/:id/discount",

    // Pickup Lists
    pickupLists: "/pickup-lists",
    pickupListDetail: "/pickup-lists/:id",
    markPrepared: "/pickup-lists/:id/mark_prepared",
    notifyParent: "/pickup-lists/:id/notify_parent",

    // Distributions
    distributions: "/distributions",
    distributionDetail: "/distributions/:id",
    markCollected: "/distributions/:id/mark_collected",
    verifyDistribution: "/distributions/:id/verify",

    // Portal endpoints (Parent access)
    portalClearance: "/portal/clearance",
    portalSelection: "/portal/selection",
  },
  audit: {
    trail: "/trail",
  },
  finance: {
    // Fee Types
    feeTypes: "/fee-types",
    feeTypeDetail: "/fee-types/:id",

    // Fee Structures
    feeStructures: "/fee-structures",
    feeStructureDetail: "/fee-structures/:id",
    feeStructureActivate: "/fee-structures/:id/activate",
    feeStructureAssignedStudents: "/fee-structures/:id/assigned-students",

    // Custom Fees
    customFees: "/custom-fees",
    customFeeDetail: "/custom-fees/:id",
    customFeeApprove: "/custom-fees/:id/approve",
    customFeeReject: "/custom-fees/:id/reject",
    customFeeBulk: "/custom-fees/bulk",

    // Payments
    payments: "/payments",
    paymentDetail: "/payments/:id",
    suspensePayments: "/payments/suspense",
    suspensePaymentDetail: "/payments/suspense/:id",
    paymentValidate: "/payments/:id/validate",
    paymentAllocate: "/payments/:id/allocate",
    paymentVoid: "/payments/:id/void",
    paymentsAllocateMissing: "/payments/allocate-missing",
    schoolpaySyncTransactions: "/schoolpay/sync-transactions",
    surepayStudentImports: "/payments/surepay/students/import",
    surepayStudentSearch: "/payments/surepay/students/search",
    surepayStudentCodeLink: "/payments/surepay/students/link",
    surepayStudentCodeUnlink: "/payments/surepay/students/link/:studentId",
    surepayStudentLink: "/payments/surepay/students/import/:importId/link",

    // Student Fee Assignments
    studentFees: "/student-fees/:spc",
    studentFeeSummary: "/student-fees/summary/:spc",
    studentFeeDiscount: "/student-fees/:id/discount",
    studentFeeAmountOverride: "/student-fees/:id/amount-override",
    studentFeeAdjustmentHistory: "/student-fees/:id/amount-adjustments",

    // Transport Fees
    transportFees: "/transport-fees",
    studentTransportFees: "/transport-fees/student/:spc",
    transportFeeSync: "/transport-fees/sync",
    transportFeesOutstanding: "/transport-fees/outstanding",
    transportReconciliation: "/transport-reconciliation",
    transportFeeDiscount: "/transport-fees/:id/discount",

    // Payment endpoints
    initiatePayment: "/payments/surepay/initiate",

    // Reconciliation
    reconciliations: "/reconciliation/daily",
    reconciliationDetail: "/reconciliation/daily/:id",

    // Departments
    departments: "/departments",
    departmentDetail: "/departments/:id",

    // Budgets
    budgets: "/budgets",
    budgetDetail: "/budgets/:id",
    budgetSubmit: "/budgets/:id/submit",
    budgetApprove: "/budgets/:id/approve",
    budgetActivate: "/budgets/:id/activate",
    budgetAddLineItems: "/budgets/:id/add_line_items",
    budgetUpdateLineItem: "/budgets/:id/update_line_item",
    budgetDeleteLineItem: "/budgets/:id/delete_line_item",

    // Requisitions
    requisitions: "/requisitions",
    requisitionDetail: "/requisitions/:id",
    requisitionSubmit: "/requisitions/:id/submit",
    requisitionHodApprove: "/requisitions/:id/hod_approval",
    requisitionFinanceApprove: "/requisitions/:id/finance_approval",
    requisitionMarkFulfilled: "/requisitions/:id/fulfill",
    requisitionCancel: "/requisitions/:id/cancel",
    requisitionAddItems: "/requisitions/:id/add_items",

    // Payroll employee and salary setup
    payrollProfiles: "/payroll/profiles",
    payrollProfileDetail: "/payroll/profiles/:id",
    payrollCreateEmployeeWithSalary: "/payroll/profiles/create-with-salary",
    payrollProfilesSummary: "/payroll/profiles/summary",
    payrollProfileTemplate: "/payroll/profiles/download-template/:format",
    payrollProfilesUpload: "/payroll/profiles/upload",
    payrollSalaryAssignments: "/payroll/salary-assignments",
    payrollSalaryAssignmentDetail: "/payroll/salary-assignments/:id",
    payrollSalaryAssignmentRevise: "/payroll/salary-assignments/:id/revise",
    payrollComponents: "/payroll/components",
    payrollComponentDetail: "/payroll/components/:id",
    payrollComponentCopyVersion: "/payroll/components/:id/copy-version",
    payrollComponentOverrides: "/payroll/component-overrides",
    payrollComponentOverrideDetail: "/payroll/component-overrides/:id",
    payrollBanks: "/payroll/banks",
    payrollBankDetail: "/payroll/banks/:id",
    payrollPaymentAccounts: "/payroll/payment-accounts",
    payrollPaymentAccountDetail: "/payroll/payment-accounts/:id",
    payrollPaymentAccountSetDefault:
      "/payroll/payment-accounts/:id/set-default",
    payrollEmployeeBankHistory: "/payroll/profiles/:id/bank-history",
    payrollAdvances: "/payroll/advances",
    payrollAdvanceDetail: "/payroll/advances/:id",
    payrollAdvanceAction: "/payroll/advances/:id/:action",
    payrollAdvanceReport: "/payroll/advances/report",
    payrollAdvanceStatement: "/payroll/advances/:id/statement",
    payrollStructures: "/payroll/structures",
    payrollStructureDetail: "/payroll/structures/:id",
    payrollStructureCopyVersion: "/payroll/structures/:id/copy-version",
    payrollScales: "/payroll/scales",
    payrollScaleDetail: "/payroll/scales/:id",
    payrollScaleCopyVersion: "/payroll/scales/:id/copy-version",
    payrollStatutoryRules: "/payroll/statutory-rules",
    payrollStatutoryRuleDetail: "/payroll/statutory-rules/:id",
    payrollStatutoryRuleCopyVersion:
      "/payroll/statutory-rules/:id/copy-version",
    payrollStatutoryRuleSimulate: "/payroll/statutory-rules/:id/simulate",
    payrollStatutoryRuleRunTests: "/payroll/statutory-rules/:id/run-tests",
    payrollStatutoryRuleTestDraft: "/payroll/statutory-rules/test-draft",
    payrollStatutoryRuleMarkTested: "/payroll/statutory-rules/:id/mark-tested",
    payrollStatutoryRuleApprove: "/payroll/statutory-rules/:id/approve",
    payrollStatutoryRuleActivate: "/payroll/statutory-rules/:id/activate",
    payrollStatutoryRuleRetire: "/payroll/statutory-rules/:id/retire",
    payrollUgandaStatutoryDefaults: "/payroll/statutory-rules/uganda-defaults",
    payrollPeriods: "/payroll/periods",
    payrollPeriodDetail: "/payroll/periods/:id",
    payrollGenerateDraft: "/payroll/periods/:id/generate-draft",
    payrollRuns: "/payroll/runs",
    payrollDashboard: "/payroll/dashboard",
    payrollValidationResults: "/payroll/validation-results",
    payrollReviewComments: "/payroll/review-comments",
    payrollApprovalHistory: "/payroll/reports/approval-history",
    payrollSecurityAccess: "/payroll/security/access",
    payrollSecurityAudit: "/payroll/security/audit",
    payrollRunReviewDashboard: "/payroll/runs/:id/review-dashboard",
    payrollRunCancel: "/payroll/runs/:id/cancel",
    payrollRunDetail: "/payroll/runs/:id",
    payrollRunSubmit: "/payroll/runs/:id/submit",
    payrollRunStartReview: "/payroll/runs/:id/start-review",
    payrollRunApprove: "/payroll/runs/:id/approve",
    payrollRunReject: "/payroll/runs/:id/reject",
    payrollRunReturnToDraft: "/payroll/runs/:id/return-to-draft",
    payrollRunFinalize: "/payroll/runs/:id/finalize",
    payrollRunCombinedPayslips: "/payroll/runs/:id/payslips/combined",
    payrollRunDraftPayslips: "/payroll/runs/:id/payslips/draft-preview",
    payrollRunPayslipsZip: "/payroll/runs/:id/payslips/zip",
    payrollRunFinalSchedule: "/payroll/runs/:id/final-payroll-schedule",
    payrollRunPayslipEmailStatus: "/payroll/runs/:id/email-status",
    payrollRunEmailPayslips: "/payroll/runs/:id/email-payslips",
    payrollPayslipVerify: "/payroll/payslips/verify/:code",
    payrollStatutoryRemittances: "/payroll/statutory-remittances",
    payrollStatutoryRemittanceRecord:
      "/payroll/statutory-remittances/:id/record",
    payrollReportExport: "/payroll/reports/export/:reportType",
    payrollReportJobs: "/payroll/report-jobs",
    payrollReportJobDownload: "/payroll/report-jobs/:id/download",
    payrollReportJobRetry: "/payroll/report-jobs/:id/retry",
    payrollReportJobsClear: "/payroll/report-jobs/clear",
    payrollOperationJobs: "/payroll/operation-jobs",
    payrollOperationJobsClear: "/payroll/operation-jobs/clear",
    payrollOperationJobRetry: "/payroll/operation-jobs/:id/retry",
    payrollOperationJobDownload: "/payroll/operation-jobs/:id/download",
    payrollReconciliations: "/payroll/reconciliations",
    payrollOperationalAlerts: "/payroll/operational-alerts",
    payrollOperationalAlertAction: "/payroll/operational-alerts/:id/:action",
    payrollRunBankSchedule: "/payroll/runs/:id/bank-payment-schedule",
    payrollRunBankPreview: "/payroll/runs/:id/bank-export-preview",
    payrollSaccoConnection: "/payroll/profiles/sacco-connection",
    payrollSaccoMembers: "/payroll/profiles/sacco-members",
    payrollSaccoLoans: "/payroll/profiles/sacco-loans",
    payrollProfileSaccoVerify: "/payroll/profiles/:id/verify-sacco-account",
    payrollProfileSaccoLoans: "/payroll/profiles/:id/sacco-employee-loans",
    payrollProfileSaccoDisbursements:
      "/payroll/profiles/:id/sacco-disbursements",
    payrollProfileSaccoLoanDetails: "/payroll/profiles/:id/sacco-loan-details",
    payrollSensitiveExportAudits: "/payroll/sensitive-export-audits",
    payrollLedgerAccounts: "/payroll/accounts",
    payrollLedgerAccountDetail: "/payroll/accounts/:id",
    payrollLedgerAccountSeedDefaults: "/payroll/accounts/seed-defaults",
    payrollAccountMappings: "/payroll/account-mappings",
    payrollAccountMappingDetail: "/payroll/account-mappings/:id",
    payrollAccountMappingCopyVersion:
      "/payroll/account-mappings/:id/copy-version",
    payrollAccountingSetupHistory: "/payroll/accounting-setup-history",
    payrollJournals: "/payroll/journals",
    payrollRunAccountingPreview: "/payroll/runs/:id/accounting-preview",
    payrollRunPostAccounting: "/payroll/runs/:id/post-accounting",
    payrollRunAccountingJournals: "/payroll/runs/:id/accounting-journals",
    payrollAccountingReports: "/payroll/reports/accounting",
    payrollRunMarkPaid: "/payroll/runs/:id/mark-paid",
    payrollRunReverse: "/payroll/runs/:id/reverse",
    payrollPayslipPdf: "/payroll/payslips/:id/pdf",
    payrollPayslipEmail: "/payroll/payslips/:id/email",
    payrollPaymentRecord: "/payroll/payments/:id/record",
    payrollManagementReports: "/payroll/reports/management",
    payrollLstReportExport: "/payroll/reports/lst-export",
    payrollInputs: "/payroll/inputs",
    payrollInputDetail: "/payroll/inputs/:id",

    // Complete Student Finances (Optimized)
    studentCompleteFinances: "/student-complete-finances/:spc",
    applyStudentCredit: "/student-complete-finances/:spc/apply-credit",

    // Financial Reports
    reportsDashboard: "/reports/dashboard",
    reportsBudgetVsActual: "/reports/budget-vs-actual",
    reportsRevenue: "/reports/revenue",
    reportsPayroll: "/reports/payroll",
    reportsExpenditure: "/reports/expenditure",
  },
  dashboard: {
    me: "/me",
  },
  lms: {
    dashboardHeadteacher: "/dashboard/headteacher",
    sessions: "/sessions",
    sessionDetail: "/sessions/:id",
    sessionActivate: "/sessions/:id/activate",
    sessionVerifyUploadKey: "/sessions/:id/verify-upload-key",
    sessionDeactivate: "/sessions/:id/deactivate",
    sessionArchive: "/sessions/:id/archive",
    content: "/content",
    contentDetail: "/content/:id",
    contentApprovals: "/content/:id/approvals",
    contentSubmit: "/content/:id/submit",
    contentPublish: "/content/:id/publish",
    contentReject: "/content/:id/reject",
    contentFiles: "/content/:id/files",
    contentFileDetail: "/content/:id/files/:fileId",
    contentUploadLog: "/content-upload-log",
    liveSessions: "/live-sessions",
    liveSessionDetail: "/live-sessions/:id",
    liveSessionAttendance: "/live-session-attendance",
    liveSessionAttendanceDetail: "/live-session-attendance/:id",
    liveSessionBulkAttendance: "/live-sessions/:id/attendance/bulk",
    liveSessionStart: "/live-sessions/:id/start",
    liveSessionEnd: "/live-sessions/:id/end",
    liveSessionJoinUrl: "/live-sessions/:id/join-url",
    liveSessionRecording: "/live-sessions/:id/recording",
    zoomIdentities: "/zoom-identities",
    zoomIdentityDetail: "/zoom-identities/:id",
    zoomIdentityProvision: "/zoom-identities/provision",
    zoomIdentityDisable: "/zoom-identities/:id/disable",
    zoomIdentityDeprovision: "/zoom-identities/:id/deprovision",
    learnerActivity: "/learner-activity",
    learnerActivityRecord: "/learner-activity/record",
    learnerContent: "/learner/content",
    learnerLiveSessions: "/learner/live-sessions",
    learnerActivitySelf: "/learner/activity",
    learnerContentStream: "/learner/content/stream/:fileId",
    quizzes: "/quizzes",
    quizDetail: "/quizzes/:id",
    quizAttempt: "/quizzes/:id/attempt",
    quizAttemptsForQuiz: "/quizzes/:id/attempts",
    quizQuestions: "/quiz-questions",
    quizQuestionDetail: "/quiz-questions/:id",
    quizAttempts: "/quiz-attempts",
    quizAttemptDetail: "/quiz-attempts/:id",
    quizAttemptFeedback: "/quiz-attempts/:id/feedback",
    quizAttemptMark: "/quiz-attempts/:id/mark",
    quizAttemptSubmit: "/quiz-attempts/:id/submit",
    weeklyReports: "/weekly-reports",
    weeklyReportDetail: "/weekly-reports/:id",
    weeklyReportReview: "/weekly-reports/:id/review",
    weeklyReportApprove: "/weekly-reports/:id/approve",
  },
};

const domainSettings = {
  dbName: "s4d_edunexus",
  dbVersion: 1,
  dbTables: [
    {
      tblName: "user",
      tblOpt: { autoIncrement: true },
      tblIndexes: [{ indexName: "user", indexOpt: { unique: true } }],
    },
  ],

  appName: "",
  appMail: "",
  institution: { name: "Hillside Nursery & Primary Schools Naalya" },
  logoWidth: 150,
  RequestsActions: { Approved: "Approved", Rejected: "Rejected" },
  storeKeys: {
    CURRENT_ITEM_TO_VIEW: "CURRENT_ITEM_TO_VIEW",
    DRAWER_STATE: "DRAWER_STATE",
  },
  backend: `https://edutest.vincita-sys.com`,
  // backend: `https://hillside.s4dedunexus.com`,
  domain: `edutest.vincita-sys.com`,
  // domain: `hillside.s4dedunexus.com`,

  base_routes,
  endpoints,
};

// Automatically generate full URLs
domainSettings.urls = Object.fromEntries(
  Object.entries(endpoints).map(([section, routes]) => [
    section,
    Object.fromEntries(
      Object.entries(routes).map(([key, path]) => [
        key,
        `${domainSettings.backend}${base_routes[section]}${path}`,
      ]),
    ),
  ]),
);

export default domainSettings;
